import { render, staticRenderFns } from "./OutrosServicos.vue?vue&type=template&id=94735e1e&scoped=true"
import script from "./OutrosServicos.vue?vue&type=script&lang=js"
export * from "./OutrosServicos.vue?vue&type=script&lang=js"
import style0 from "./OutrosServicos.vue?vue&type=style&index=0&id=94735e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94735e1e",
  null
  
)

export default component.exports